<template>
  <div v-if="!loading && event">
    <section v-if="showHeader || event.subHeader">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 v-if="showHeader">{{ event.header }}</h1>
            <p class="h5" v-if="event.subHeader">{{ event.subHeader }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="bg-warning mt-4" v-if="currentCode">
      <div class="container">
        <section class="row">
          <div class="col">
            <player :event="event"></player>
          </div>
        </section>
      </div>
    </div>

    <div class="container" v-if="currentCode && event.codesEnabled">
      <div class="row">
        <div class="col text-right">
          <a href="javascript:;" class="d-inline-block mt-2" @click="closePlayer">Leave</a>
        </div>
      </div>
    </div>

    <section class="container mt-4">
      <div class="row" v-if="currentCode">
        <div class="col-12 col-md-6">
          <event-image :event="event"></event-image>
        </div>
        <div class="col-12 col-md-6">
          <div class="col-12 mb-4" style="line-height: 1.8;" v-if="event.contentSignedIn" v-html="event.contentSignedIn"></div>
          <div class="col-12 mb-4" style="line-height: 1.8;" v-if="event.contentAgenda" v-html="event.contentAgenda"></div>
        </div>
        <div class="col-12 mt-4" v-if="event.qnaEnabled">
          <h3>Questions</h3>
          <p>Send in your questions here:</p>
          <qna-form :event-id="event.id"></qna-form>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12 py-4 text-center">
          <event-image :event="event"></event-image>
        </div>

        <div class="col-12 mb-4" v-html="event.contentDefault"></div>

        <div class="col-6">
          <p>To participate you have to enter the participation code you have received. The live event is available on most devices using modern web browsers. If you have any problems, please try another browser or device. Ad blockers should be turned off.</p>
        </div>
        
        <redeem-form :event="event" class="col-6"></redeem-form>
      </div>
    </section>
  </div>
  <div class="py-5 my-5 d-flex align-items-center justify-content-center" v-else>
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import RedeemForm from "@/components/redeem-form.vue"
  import Player from "@/components/player.vue"
  import EventImage from "@/components/event-image.vue"
  import QnaForm from "@/components/qna-form.vue"

  export default {
    name: "home",
    components: { RedeemForm, Player, EventImage, QnaForm },
    props: {
      id: {
        type: String,
        required: true
      },
      showHeader: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        loading: true,
        sending: false,
        event: null,
        questionName: null,
        questionQuestion: null,
        questionThanks: null
      }
    },
    computed: {
      currentCode() {
        if(this.event.codesEnabled) {
          return this.$store.state.currentCode && this.$store.state.currentCode[this.event.id] && this.$store.state.currentCode[this.event.id].codeString
        } else {
          return true
        }
      },
      ticketValid() {
        return ""
      }
    },
    methods: {
      closePlayer() {
        let object = {}
        object[this.event.id] = { codeString: null }
        this.$store.commit("setCurrentCode", object)
      },
      async sendQuestion() {
        if(!this.questionFormValid) { return false }
        this.sending = true

        await firebase.firestore().collection(`questions`).add({
          name: this.questionName,
          question: this.questionQuestion,
          created: firebase.firestore.FieldValue.serverTimestamp()
        })

        this.questionQuestion = null
        this.questionThanks = "Thank you for your question. We will try to answer it!"
        this.sending = false

        setTimeout(() => {
          this.questionThanks = null
        }, 5000)
      }
    },
    async mounted() {
      await this.$bind("event", firebase.firestore().collection(`events`).doc(this.id))

      if(this.event && this.event.active) {
        this.loading = false
      } else {
        this.$router.replace({ name: "home" })
      }
    }
  }
</script>

<style lang="scss" scoped>
  
</style>